import React from 'react';
import LoadingIcon from "../../assets/icons/loading";
import DOMPurify from "dompurify";

export default function Loader({ text = null }) {
    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-85 p-6">
            <LoadingIcon />
            <span className="text-white font-bold text-xl mt-6 text-center" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
        </div>
    );
};
